import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type PromosState = {
  readonly errorCode: string;
  readonly wasSuccessfullyApplied: boolean;
};

const initialState: PromosState = {
  errorCode: '',
  wasSuccessfullyApplied: false,
};

const promosReducer = (state: PromosState = initialState, action: ActionTypes): PromosState => {
  switch (action.type) {
    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE:
      return {
        ...state,
        errorCode: '',
        wasSuccessfullyApplied: false,
      };

    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_ERROR:
      return {
        ...state,
        errorCode: action.error.message,
        wasSuccessfullyApplied: false,
      };

    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_SUCCESS:
      return {
        ...state,
        errorCode: '',
        wasSuccessfullyApplied: true,
      };

    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_SUCCESS_CLEAR:
      return {
        ...state,
        errorCode: '',
        wasSuccessfullyApplied: false,
      };

    default:
      return state;
  }
};

export default promosReducer;
